<template>
  <div style="padding: 2%;background-color: gainsboro;">
    <div class="advertising" v-if="url!=''">
      <img :src="url" @click="clickUrl()" width="100%" height="100%" />
    </div>
    <van-tabs v-model="active" @click="onClick">
      <van-tab title="历史记录" name="0" style="height: 100%;">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" style="overflow: scroll; height: calc(75vh);">
          <van-cell v-for="item in list" :key="item" class="cell">
            <template>
              <div class="div_list" @click="payInfo(item.orderId,item.opType,0)">
                <div>
                  <div class="div_left">{{item.orderMap.carNum}}</div>
                  <div class="div_right">查看详情》</div>
                  <div class="div_clear"></div>
                </div>
                <div class="div_zt">
                  <div>
                    <div class="div_left">入场时间:{{item.orderMap.startTime}}</div>
                    <div class="div_right">正常离场</div>
                    <div class="div_clear"></div>
                  </div>
                  <div>
                    <div class="div_left">出场时间:{{item.orderMap.leaveTime}}</div>
                    <div class="div_right">¥{{$moneyFormat.RMB(item.orderMap.shouldPayMoney)}}</div>
                    <div class="div_clear"></div>
                  </div>
                </div>
                <div>
                  <div class="div_left">{{item.orderMap.parkName}}</div>
                  <div class="div_right">停车时长：{{item.orderMap.parkingCarTimes}}</div>
                  <div class="div_clear"></div>
                </div>
              </div>
            </template>
          </van-cell>
        </van-list>
      </van-tab>
      <van-tab title="待缴费记录" name="1" style="height: 100%;">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="noPayRecord" style="overflow: scroll; height: calc(75vh)">
          <van-cell v-for="noPay in noPayList" :key="noPay.parkingOrderId" class="cell">
            <template>
              <div class="div_list" @click="payInfo(noPay.parkingOrderId,2,1)">
                <div>
                  <div class="div_left">{{noPay.carNum}}</div>
                  <div class="div_right">查看详情》</div>
                  <div class="div_clear"></div>
                </div>
                <div class="div_zt">
                  <div>
                    <div class="div_left">入场时间:{{noPay.startTime}}</div>
                    <div v-if="noPay.status == 1" class="div_right font_red">待缴费</div>
                    <div v-if="noPay.status == 0" class="div_right font_red">未缴费</div>
                    <div class="div_clear"></div>
                  </div>
                  <div>
                    <div class="div_left">出场时间:{{noPay.leaveTime}}</div>
                    <div class="div_right font_red">¥{{(noPay.noPayMoney).toFixed(2)}}</div>
                    <div class="div_clear"></div>
                  </div>
                </div>
                <div>
                  <div class="div_left">{{noPay.parkName}}</div>
                  <div class="div_right">停车时长：{{noPay.parkingCarTimes}}</div>
                  <div class="div_clear"></div>
                </div>
              </div>
            </template>
          </van-cell>
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
  import {
    mySessionStorage
  } from '@/utils/storage.js'
  export default {
    data() {
      return {
        url: "", //展示图片
        cUrl: "", //点击跳转地址
        continue: 0,
        name: 0,
        list: [],
        noPayList: [],
        loading: false,
        finished: false,
        openid: "",
        active: "0",
        query: {
          year: "",
        }
      };
    },
    methods: {
      onClick(name, title) {
        this.finished = false;
        this.loading = false;
        this.list = [];
        this.noPayList = [];
        this.query.year = this.doHandleYear();
        if (name == 0) {
          this.parkingRecord();
          this.onLoad();
        } else {
          this.noPayRecord();
        }
      },
      onLoad() {
        setTimeout(() => {
          if (this.list.length == 0) { //数据获取为空  结束当前请求
            if (this.query.year > 2020) {
              this.query.year = this.query.year - 1;
              this.continue++;
              return
            } else {
              this.finished = true;
              return
            }
          }
          if (this.query.year > 2020) {
            this.query.year = this.query.year - 1;
            this.continue++;
            return
          } else {
            this.finished = true;
            return
          }
          this.loading = false;
        }, 1000);
      },
      parkingRecord() {
        this.$http.post(this.$api.parkingRecord + "/" + this.openid, {
          ...this.query
        }).then(res => {
          if (res.code = 200) {
            this.list = this.list.concat(res.data);
          } else {
            this.list = this.list.concat([]);
          }
        });
      },
      noPayRecord() {
        this.$http.post(this.$api.noPayRecord + "/" + this.openid, {
          ...this.query
        }).then(res => {
          if (res.code == 200) {
            this.noPayList = res.data;
          } else {
            this.noPayList = [];
          }
          this.finished = true;
        });
      },
      payInfo(id, type, noPay) {
        this.$router.push({
          path: '/recordInfo',
          query: {
            orderId: id,
            opType: type,
            noPay: noPay
          }
        });
      },
      getopenId() {
        this.active = mySessionStorage.getItem("active");
        if (mySessionStorage.getItem("openid") != null && mySessionStorage.getItem("openid") != "" && mySessionStorage.getItem("openid") != "") {
          this.openid = mySessionStorage.getItem("openid");
        } else {
          this.$getOpenid().then(res => {
            this.openid = mySessionStorage.getItem("openid");
            console.log("--------------------------", this.openid);
          });
        }
      },
      doHandleYear() {
        var myDate = new Date();
        return myDate.getFullYear();
      },
      //广告加载
      getAdvertisingInfo() {
        this.$axios({
            url: this.$api.payDetails,
            method: "get",
          })
          .then(res => {
            this.url = res.data.data.creativeImg.creativeUrl;
            this.cUrl = res.data.data.landingPage;
            let trackUrl = res.data.data.trackUrl;
            this.$axios({
              url: trackUrl,
              method: "get",
            }).then(res => {
              console.log(res)
            });
            console.log(res.data);
          })
      },
      clickUrl() {
        window.location.href = this.cUrl;
      }
    },
    created() {},
    mounted() {
      this.getAdvertisingInfo();
      this.query.year = this.doHandleYear();
      //mySessionStorage.setItem("openid", "o1KC-wsvSK2iAGTF0V-v0iRUmdw0");
      //mySessionStorage.setItem("openid", "o1KC-wrFgQHGHoSYthMJscBYjYZ4");
      this.getopenId();
      if (this.active == "1") {
        this.onClick(1,0)
      } else {
        this.onClick(0,0)
      }
      this.loading = false;
    },
    computed: {
      getContinue() {
        return this.continue;
      }
    },
    watch: {
      getContinue(data) {
        if (this.active != "1") {
          this.parkingRecord();
          this.onLoad();
        }
      },
    }
  };
</script>

<style>
  .div_left {
    float: left;
  }

  .div_right {
    float: right;
  }

  .div_clear {
    clear: both;
  }

  .div_list {
    padding: 2% 1%;
  }

  .font_red {
    color: red;
  }

  .div_zt {
    background-color: #F39900;
  }

  .cell {
    margin: 1% 0px;
    background: whitesmoke;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/parkingRecord/record.vue